import { Box, Checkbox, IconButton, Typography } from "@mui/material"
import List from "@mui/material/List"
import ListItemButton from "@mui/material/ListItemButton"
import ListItemText from "@mui/material/ListItemText"
import Collapse from "@mui/material/Collapse"
import ExpandLess from "@mui/icons-material/ExpandLess"
import ExpandMore from "@mui/icons-material/ExpandMore"
import { useDispatch, useSelector } from "react-redux"
import {
  collapseCategory,
  expandCategory,
  setPerms,
} from "../../../redux/slices/rolesAndPermsSlice"
import { setLoading } from "../../../redux/slices/appSlice"
import { useEffect, useState } from "react"
import {
  addModulePermission,
  addPermission,
  removeModulePermission,
  removePermission,
} from "."
import { useNavigate } from "react-router"
import { PermissionTableHeader, PermissionTableWrapper } from "./Atom"
import { getTokenLocal } from "../../../../helper/utils"
import { permissions } from "../../../../config/constants"

const label = { inputProps: { "aria-label": "Checkbox demo" } }

type PermissionsTableProps = {}

const PermissionsTable = (props: PermissionsTableProps) => {
  const token: any = getTokenLocal()
  const dispatch = useDispatch()

  const [modules, setModules] = useState([])

  const allPerms = useSelector((state: any) => {
    return state.rolesAndPerms.userPerms
  })

  const state = useSelector((state: any) => {
    return state.rolesAndPerms.perms
  })

  const rolesAndPerms = useSelector((state: any) => {
    return state.rolesAndPerms
  })

  const navigate = useNavigate()

  const handleModuleCheck = async (e: any, currentModule: any, role: any) => {
    dispatch(setLoading(true))
    if (e?.target?.checked) {
      const result: any = await addModulePermission(
        state,
        currentModule,
        role,
        token,
      )

      if (result?.isAuthorized) {
        dispatch(setPerms([...result?.tempModules]))
      } else {
        navigate("/auth")
      }
    } else {
      const result: any = await removeModulePermission(
        state,
        currentModule,
        role,
        token,
      )

      if (result?.isAuthorized) {
        dispatch(setPerms([...result?.tempModules]))
      } else {
        navigate("/auth")
      }
    }
    dispatch(setLoading(false))
  }

  const handlePermCheck = async (
    e: any,
    moduleName: any,
    role: any,
    permId: any,
  ) => {
    dispatch(setLoading(true))
    if (e?.target?.checked) {
      const result: any = await addPermission(
        state,
        moduleName,
        role,
        permId,
        token,
      )

      console.log("result", result)

      if (result?.isAuthorized) {
        dispatch(setPerms([...result?.tempModules]))
      } else {
        navigate("/auth")
      }
    } else {
      const result: any = await removePermission(
        state,
        moduleName,
        role,
        permId,
        token,
      )

      if (result?.isAuthorized) {
        dispatch(setPerms([...result?.tempModules]))
      } else {
        navigate("/auth")
      }
    }
    dispatch(setLoading(false))
  }

  useEffect(() => {
    setModules(state)
  }, [rolesAndPerms])

  return (
    <PermissionTableWrapper>
      <PermissionTableHeader>
        <Typography
          sx={{
            marginLeft: "10px",
          }}
        >
          Application Components
        </Typography>
      </PermissionTableHeader>
      <Box sx={{ overflowY: "scroll" }}>
        {modules.map((module: any, index: any) => (
          <List
            id={module?.module_name}
            sx={{
              width: "100%",
              padding: "0",
              // bgcolor: 'background.paper'
            }}
            component="nav"
          >
            <ListItemButton
              disableRipple={true}
              // onClick={() => handleClick(category?.id)}
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                height: "50px",
                // border: "1px solid red"
                // marginLeft: perm?.type == "macro" ? "0px" : "10px"
              }}
            >
              <Checkbox
                sx={{
                  padding: "0",
                  // color: "#FFFFFF"
                }}
                name={module?.module_name}
                {...label}
                checked={module?.is_assigned}
                onChange={(e: any) =>
                  handleModuleCheck(e, module, module?.role)
                }
                disabled={
                  module?.role == "admin" ||
                  !allPerms?.includes(permissions?.ASSIGN_PERMISSIONS_TO_ROLES)
                  // ||
                  // module?.module_name == "USER MANAGEMENT"
                  // ||
                  // module?.module_name == "CUSTOMER MANAGEMENT"
                  // ||
                  // module?.module_name == "HUDDLE"
                }
                indeterminate={
                  module?.is_assigned ? false : module?.indeterminate
                }
              />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
                onClick={() => {
                  module?.open
                    ? dispatch(collapseCategory(module?.module_name))
                    : dispatch(expandCategory(module?.module_name))
                }}
              >
                <ListItemText
                  sx={{ marginLeft: "10px", color: "#3F68CF" }}
                  primary={module?.module_name}
                />
                {module?.open ? (
                  <IconButton>
                    <ExpandLess />
                  </IconButton>
                ) : (
                  <IconButton>
                    <ExpandMore />
                  </IconButton>
                )}
              </Box>
            </ListItemButton>
            <Collapse in={module?.open} timeout="auto" unmountOnExit>
              {module?.permissions?.map((perm: any) => (
                <List id={perm?.id} component="div" disablePadding>
                  <ListItemButton disableRipple={true} sx={{ pl: 4 }}>
                    <Checkbox
                      sx={{
                        padding: "0",
                        // color: "#FFFFFF"
                      }}
                      {...label}
                      checked={perm?.is_assigned}
                      onChange={(e: any) =>
                        handlePermCheck(
                          e,
                          module?.module_name,
                          module?.role,
                          perm?.id,
                        )
                      }
                      disabled={
                        module?.role == "admin" ||
                        !allPerms?.includes(
                          permissions?.ASSIGN_PERMISSIONS_TO_ROLES,
                        )
                        // ||
                        // module?.module_name == "USER MANAGEMENT"
                        // ||
                        // module?.module_name == "CUSTOMER MANAGEMENT"
                        // ||
                        // module?.module_name == "HUDDLE"
                      }
                    />
                    <ListItemText
                      sx={{ marginLeft: "10px" }}
                      primary={perm?.name}
                    />
                  </ListItemButton>
                </List>
              ))}
            </Collapse>
          </List>
        ))}
      </Box>
    </PermissionTableWrapper>
  )
}

export default PermissionsTable
